import { lazy } from 'react';

export const TeacherModuleLessonsPage = lazy(() => import('./TeacherModuleLessonsPage'));
